export default "__VITE_ASSET__WAzsot4d__"